(function () {
    'use strict';

    angular
        .module('controlEditModule')
        .controller('ControlEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'topBarService', 'historyCtxtService', 'permissionService', 'grcControlService', 'commonAricService', 'authenticatedUser', 'govProcess', 'control'];

    function Controller($scope, $state, $stateParams, topBarService, historyCtxtService, permissionService, grcControlService, commonAricService, authenticatedUser, govProcess, control) {

        topBarService.setTitleAndIcon('Edit Control', 'fa fa-eye');

        if (!$state.is('controlAdd') && (_.isUndefined(control) || _.isEmpty(control))) {
            $state.go('controlNotExists', { ControlID: $stateParams.ControlID });
            return;
        }

        $scope.authenticatedUser             = authenticatedUser;
        $scope.govProcess                    = govProcess;
        $scope.control                       = control;
        $scope.controlTestResults = {};

        $scope.controlPermissions = $scope.control._GOV;

        // Can Edit Assessment?
        $scope.canEditAssessment = permissionService.hasPermission('ControlGrpBusinessUnit_GovernanceManagement', 'Assessment', 'Edit');

        // Update Control To Assess
        $scope.updateControlToAssess = function (updatedControlToAssess) {
            $scope.control.ControlAssessment = updatedControlToAssess.Assessment;
            return updatedControlToAssess;
        };

        // Get Control to Assess
        $scope.getControlToAssess = function () {
            return commonAricService
                    .getControlToAssess($scope.control.ControlID)
                    .then($scope.updateControlToAssess);
        };
    
        // Go To Risk
        $scope.goToRisk = function (item) {
            historyCtxtService.goToState('riskEdit',
                { RiskID: item.RiskID },
                'control',
                control
            );
        };

        // Go To Control
        $scope.goToControl = function (item) {
            $state.go('control', { ControlID: item.ControlID });
        };

        // Go To Control Assessment
        $scope.goToControlAssessment = function () {
            $state.go('control.assessment');
        };

        // Go To Control Review
        $scope.goToControlReview = function () {
            $state.go('control.review');
        };

        // Go To Control Related Risks
        $scope.goToControlRelatedRisks = function () {
            $state.go('control.relatedRisks');
        };

        // Go To Control History
        $scope.getHistoricOnControl = function (item) {
            if (_.isUndefined(item.ControlID)) return;
            return grcControlService.getHistoricOnControl(item.ControlID);
        }

        // Get History Assessments
        $scope.getHistoryAssessments = function (item) {
            if (_.isUndefined(item.ControlID)) return;

            return commonAricService
                    .getAssessmentsByControlId(item.ControlID)
                    .then(function (assessments) {
                        return _.filter(assessments, {
                            Assessment: {
                                GovernanceProcess: { IsActive: false }
                            }
                        });
                    });
        };

        $scope.goToControlHistory = function () {
            $state.go('control.history');
        };

        // Go To Control Tests
        $scope.createControlTest = function () {
            $state.go('control.addControlTest');
        };

        $scope.goToControlTests = function () {
            $state.go('control.controlTests');
        };

        $scope.goToControlTest = function (item) {
            if (_.isUndefined(item.ControlID)) return;
            if (_.isUndefined(item.ControlTestID)) return;

            $state.go('control.controlTests.edit', {
                ControlID: item.ControlID,
                ControlTestID: item.ControlTestID
            });            
        }

        // Test Results
        $scope.goToTestResult = function () {
            $state.go('control.controlTests.edit.testresult');
        }

        $scope.getTestResults = function (controlTest) {
            return grcControlService.getTestResults(controlTest.ControlID, controlTest.ControlTestID);
        }

        // Observations
        $scope.goToObservations = function () {
            $state.go('control.observations');
        }
    }
})();